import { Component, Input, OnInit, inject } from '@angular/core';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { AppAccessDeniedReason } from '../../../core/services/subscription/app-access.service';

@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css'],
})
export class AccessDeniedComponent implements OnInit {
  @Input() reason?: AppAccessDeniedReason;

  private readonly keycloak = inject(Keycloak);
  private readonly translate = inject(TranslateService);

  username = '';

  ngOnInit(): void {
    void this.keycloak.loadUserProfile().then((profile: KeycloakProfile) => {
      this.username = profile.username || profile.email || 'Użytkownik';
    }).catch(() => {
      this.username = 'Użytkownik';
    });
  }

  logout(): void {
    void this.keycloak.logout({ redirectUri: window.location.origin }).catch(() => {
      window.location.href =
        `${environment.keycloakUrl}/realms/${environment.realm}/protocol/openid-connect/logout` +
        `?client_id=${environment.clientId}` +
        `&post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
    });
  }

  getTitle(): string {
    return this.translate.instant(this.translationKey('title'));
  }

  getMessage(): string {
    return this.translate.instant(this.translationKey('message'));
  }

  getDescription(): string {
    return this.translate.instant(this.translationKey('description'));
  }

  getLogoutButtonText(): string {
    return this.translate.instant('accessDenied.logoutButton');
  }

  private translationKey(part: string): string {
    return this.reason ? `accessDenied.${this.reason}.${part}` : `accessDenied.${part}`;
  }
}
